/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';

import { IHtmlBlockProps } from './html-block.props.autogenerated';

export interface IHtmlBlockViewProps extends IHtmlBlockProps<{}> {
    content?: React.ReactNode;
    className?: string;
}

/**
 *
 * HtmlBlock component
 * @extends {React.PureComponent<IHtmlBlockProps<{}>>}
 */
class HtmlBlock extends React.PureComponent<IHtmlBlockProps<{}>> {
    public render(): JSX.Element | null {
        const { content, className } = this.props.config;
        const text = content && (
            <MsDyn365.RichTextComponent
                text={content}
                editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }}
            />
        );
        const htmlBlockViewProps = {
            ...this.props,
            content: text,
            className: classnames('ms-html-block', className)
        };
        return this.props.renderView(htmlBlockViewProps) as React.ReactElement;
    }

    public handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.content = event.target.value);
}

export default HtmlBlock;
